export default __webpack_public_path__ + "static/media/raiffeisen_background_s1.e80180be.jpg";